import { siteName } from 'src/utils/oneCodeBase.js'

export const META_DATA = {
  homePage: {
    title: `FirstWord ${siteName} - Industry News and Analysis`,
    description:
      'Stay updated with the latest news, insights, and analysis in the pharmaceutical industry. FirstWord provides comprehensive coverage of key developments and trends.'
  },
  registerPage: {
    title: `Register for FirstWord ${siteName}`,
    description:
      'Register for a FirstWord account to access personalized content and features.'
  },
  loginPage: {
    title: `Sign in to FirstWord ${siteName}`,
    description:
      'Sign in to your FirstWord account to access personalized content and features.'
  },
  //* Rivers
  'Top Stories': {
    title: 'Top Stories',
    description:
      'Explore the latest top stories in the pharmaceutical industry.'
  },
  'product news & analysis': {
    title: 'Product News & Analysis',
    description:
      'Get the latest news and analysis on pharmaceutical products and innovations.'
  },
  'condition news & analysis': {
    title: 'Condition News & Analysis',
    description:
      'Stay informed about the latest developments in various medical conditions.'
  },
  'regulatory news & analysis': {
    title: 'Regulatory News & Analysis',
    description:
      'Access the latest news and analysis on pharmaceutical regulations and compliance.'
  }
}
